var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { getOwner } from '@ember/application';
import * as Sentry from '@sentry/ember';
/**
 * This service is responsible for fetching and caching the MFE manifests.
 */
let SingleSpaManifest = (_class = class SingleSpaManifest extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "environment", _descriptor, this);
    _defineProperty(this, "cachedManifests", {});
    _defineProperty(this, "defaultLocalhostPort", '5173');
  }
  get config() {
    return getOwner(this).resolveRegistration('config:environment');
  }

  /**
   * Retrieves the contents of the manifest file for a specified MFE.
   *
   * This function checks if the manifest is already cached. If it is, it returns the cached
   * version. Otherwise, it fetches the manifest from the specified path.
   * @param manifestPath The path of the manifest file.
   * @param mfeName (Optional) The name of the MFE. This is used to fetch environment variables for local development.
   * @returns A promise that resolves to the manifest contents.
   */
  async getManifest(manifestPath, mfeName) {
    const manifest = this.cachedManifests[manifestPath];
    if (manifest) {
      return manifest;
    }
    const app = await this.fetchManifest(manifestPath, mfeName);
    this.cachedManifests[manifestPath] = app;
    return app;
  }
  async fetchManifest(manifestPath, mfeName) {
    const envConfig = mfeName ? this.config.dashboardMFE?.[mfeName] ?? {} : {};
    const endpoint = this.getEndpoint(manifestPath, {
      useLocalIntegration: envConfig.enabled,
      port: envConfig.localhostPort
    });
    const response = await fetch(endpoint).then(res => {
      if (res.ok) {
        return res.json();
      }
      throw new Error(`Failed to load manifest: ${res.status}`);
    }).catch(e => {
      Sentry.captureException(e);
    });
    return response.app;
  }
  getEndpoint(manifestPath, options) {
    const {
      isDevelopment,
      isProduction,
      isSandbox,
      isTesting
    } = this.environment;
    const useLocalIntegration = options?.useLocalIntegration ?? false;
    const port = options?.port ?? this.defaultLocalhostPort;
    if (isTesting) {
      return manifestPath;
    } else if (isDevelopment && useLocalIntegration) {
      return `http://localhost:${port}${manifestPath}`;
    } else if (isProduction || isSandbox) {
      return `https://app.squareup.com${manifestPath}`;
    } else {
      return `https://app.squareupstaging.com${manifestPath}`;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "environment", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { SingleSpaManifest as default };